import type { FaireProductEntity } from "../../entity_types/product";

export const p_sw3fxgpwte: FaireProductEntity = {
  token: "p_sw3fxgpwte",
  type: "product",
  name: "Cauldron Halloween Bath Bomb w/ Bubbling Frosting",
  brandToken: "b_zads5ze6zx",
  brandName: "Bath bombs by jay",
  imageUrl:
    "https://cdn.faire.com/fastly/aa672f7447beff96061fcd0fcdd3ab2d4656d18bff9ffb57f4a88474e3de5b1c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dcb63cb6fe3cd245201563656eb36bc4fd1f59044261fa9a1b986c8d6f5bafc6.jpeg",
  ],
  priceDollars: 6,
  description:
    "• Bubbling frosting\n• Cauldron is also a bath bomb\n• Has bath bomb filling inside the cauldron \n• Scent: Fern forest\n• Made with natural ingredients \n• Individually wrapped",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:42.881Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
